<nav aria-label="Paginatie" class="aeg-pagination" role="navigation">
    <div class="aeg-pagination__list">
        <div v-if="pagePosition"
             id="pagePosition"
             class="aeg-pagination__list__item aeg-pagination__list__item--position"
             v-html="pagePosition"/>
    </div>

    <div class="aeg-pagination__list">
        <template v-if="pageCount > 1">
            <div :class="{'aeg-pagination__list__item': true, 'aeg-pagination__list__item--previous': true, 'aeg-pagination__list__item--disabled' : !prevButtonActive}">
                <component
                        :is="prevButtonActive ? 'a' : 'span'"
                        :aria-label="prevButtonActive ? `Ga naar de vorige pagina` : null"
                        :href="prevButtonActive ? '#' : null"
                        class="vl-link"
                        @click.prevent="prevButtonActive ? changePage(currentPage - 1) : null">
                    <vl-icon class="vl-link__icon vl-link__icon--before" icon="nav-left"/>
                    Vorige
                </component>
            </div>
            <div v-for="page in pagination"
                 :key="page !== '...' ? 'page-' + page : null"
                 :class="{'aeg-pagination__list__item': true, 'aeg-pagination__list__item--current': isCurrentPage(page)}">
                <component
                        :is="!isCurrentPage(page) && page !== '...' ? 'vl-link' : 'span'"
                        :aria-current="isCurrentPage(page) ? true : null"
                        :aria-label="!isCurrentPage(page) && page !== '...' ? `Ga naar pagina ${page}` : null"
                        :href="!isCurrentPage(page) && page !== '...' ? '#' : null"
                        v-html="page"
                        @click.prevent="!isCurrentPage(page) && page !== '...' ? changePage(parseInt(page)) : null"/>
            </div>
            <div :class="{'aeg-pagination__list__item': true, 'aeg-pagination__list__item--next': true, 'aeg-pagination__list__item--disabled' : !nextButtonActive}">
                <component
                        :is="nextButtonActive ? 'a' : 'span'"
                        :aria-label="nextButtonActive ? `Ga naar de volgende pagina` : null"
                        :href="nextButtonActive ? '#' : null"
                        class="vl-link"
                        @click.prevent="nextButtonActive ? changePage(currentPage + 1) : null">
                    Volgende
                    <vl-icon class="vl-link__icon vl-link__icon--after" icon="nav-right"/>
                </component>
            </div>
        </template>
    </div>
</nav>
